import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import { useDispatch, useSelector } from "react-redux";
import SecurityIcon from "@mui/icons-material/Security";
import ItemInputCard from "~business/Cards/ItemInputCard";
import type { FieldChangeEvent } from "~business/Cards/types";

import {
  setNombreConductor,
  setApellidoConductor,
  setNumeroDocumentoConductor,
  setSubmitting,
} from "../actions";
import { CampoSiniestro } from "../../../types";

interface SliceDatosConductor {
  nombreConductor: CampoSiniestro;
  apellidoConductor: CampoSiniestro;
  numeroDocumentoConductor: CampoSiniestro;
}

const useReduxSelector = () =>
  useSelector<any, SliceDatosConductor>((state) => ({
    nombreConductor: state.cargaSiniestroReducer.nombreConductorSelected,
    apellidoConductor: state.cargaSiniestroReducer.apellidoConductorSelected,
    numeroDocumentoConductor:
      state.cargaSiniestroReducer.numeroDocumentoConductorSelected,
  }));

const title = "Datos del Conductor";

interface DatosConductorCardProps {
  isLoading?: boolean;
}

const DatosConductorCard = ({ isLoading }: DatosConductorCardProps) => {
  const dispatch = useDispatch();

  const { nombreConductor, apellidoConductor, numeroDocumentoConductor } =
    useReduxSelector();

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleChangeNombreConductor = (
    nombre: FieldChangeEvent<string | null>
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNombreConductor(nombre));
    }, 200);
  };

  const handleChangeApellidoConductor = (
    apellido: FieldChangeEvent<string | null>
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setApellidoConductor(apellido));
    }, 200);
  };

  const handleChangeNumeroDocumentoConductor = (
    dni: FieldChangeEvent<string | null>
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNumeroDocumentoConductor(dni));
    }, 200);
  };

  const handleBlur = () => {
    dispatch(setSubmitting(false));
  };

  return (
    <>
      <DetalleCard title={title} IconHeader={SecurityIcon}>
        <ItemInputCard
          id={"nombreConductor"}
          isLoading={isLoading}
          label={"Nombre"}
          value={nombreConductor.value}
          onChange={handleChangeNombreConductor}
          onBlur={handleBlur}
          focus={nombreConductor.focus}
          required
        />
        <ItemInputCard
          id={"apellido"}
          isLoading={isLoading}
          label={"Apellido"}
          value={apellidoConductor.value}
          onChange={handleChangeApellidoConductor}
          onBlur={handleBlur}
          focus={apellidoConductor.focus}
          required
        />
        <ItemInputCard
          id={"documento"}
          isLoading={isLoading}
          label={"Número de Documento"}
          value={numeroDocumentoConductor.value}
          onChange={handleChangeNumeroDocumentoConductor}
          onBlur={handleBlur}
          focus={numeroDocumentoConductor.focus}
          required
        />
      </DetalleCard>
    </>
  );
};

export default DatosConductorCard;
